import { mergeClassnames } from '@heathmont/moon-core-tw';

const Keyline: FC<{ className?: string }> = ({ className }) => (
  <hr className={mergeClassnames('h-px border-0 bg-beerus', className)} />
);

export default Keyline;
